import React from 'react';

import CheckboxInput from 'ui-library/inputs/CheckboxInput';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import {InputChangeEvent} from 'util/Types';

export interface FreezeThawSettings {
  isEnabled: boolean;
  limit: number | null;
}

interface FreezeThawSettingsProps {
  isWritable: boolean;
  onUpdate: (settings: FreezeThawSettings) => void;
  settings: FreezeThawSettings;
}

export default function FreezeThawCheckbox(props: FreezeThawSettingsProps): JSX.Element {
  function handleFreezeThawTrackingCheckboxChange(e: InputChangeEvent): void {
    props.onUpdate({...props.settings, isEnabled: e.target.checked});
  }

  return (
    <div>
      <div className="u-flex-display">
        <CheckboxInput
          label=""
          id="toggle-freeze-thaw-checkbox"
          checked={props.settings.isEnabled}
          onChange={handleFreezeThawTrackingCheckboxChange}
          disabled={!props.isWritable}
        />
        <FieldLabel label="Enable freeze/thaw tracking" />
      </div>
      <div className="u-padding-left">
        <div className="u-base-text">
          {/* Keep in sync with back-end
          `ImplementedFreezeThawTrackingSchemaInterfaceHandler:HELP_TEXT_FOR_ADDING_INTERFACE_TO_EXISTING_SCHEMA` */}
          Add “Freeze/thaw count” as a system field on all containers holding entities of this schema. This
          cannot be disabled once it is enabled.
        </div>
      </div>
    </div>
  );
}
